import {
  IApplicationContext,
  IWidgetApplicationContext,
  IWidgetHandlerContext,
} from '../../../../shared/types/widgetContext';
import { createMicrofrontendUI } from '../createMicrofrontendUI';
import { renderPaymentWidgetHandler, renderDepositWidgetHandler } from './handlers';
import { exportsModule } from '@cian/mf-registry/browser';

export const initMicrofrontend = (context: IApplicationContext) => {
  const { config, httpApi, logger, telemetry, store, widgetResultObserver } = context;

  const applicationContext: IWidgetApplicationContext = {
    config,
    httpApi,
    logger,
    telemetry,
    resolveWidgetResult: widgetResultObserver.resolve,
  };
  const apiContext: IWidgetHandlerContext = {
    config,
    httpApi,
    logger,
    telemetry,
    store,
    getWidgetResultObserver: widgetResultObserver.get,
  };

  exportsModule({
    ui: {
      '/public/v1/get-widget/': createMicrofrontendUI({ context: applicationContext, store }),
    },
    api: () => [
      {
        path: '/v1/render-deposit-widget',
        handler: renderDepositWidgetHandler(apiContext, false),
      },
      {
        path: '/v1/render-payment-widget',
        handler: renderPaymentWidgetHandler(apiContext, false),
      },
      {
        path: '/v1/open-deposit-modal',
        handler: renderDepositWidgetHandler(apiContext, true),
      },
      {
        path: '/v1/open-payment-modal',
        handler: renderPaymentWidgetHandler(apiContext, true),
      },
    ],
  });
};
